export default defineNuxtRouteMiddleware(async (to, from) => {
  if (process.client && to.fullPath !== from.fullPath) {
    const store = useStore()
    const { load } = storeToRefs(store)
    if (!load.value) {
      load.value = true
      const links = document.links
      const url: any[] = []
      for (let i = 0; i < links.length; i++) {
        const cache = ['k', 'tor', 'b', 'p']
        const pathname = links[i].pathname
        if (cache.includes(pathname.split('/')[1]) && !url.includes(pathname)) {
          url.push(pathname)
        }
      }
      $fetch('/load', {
        method: 'POST',
        body: url
      }).then(() => {
        load.value = false
      })
    }
  }
})
